import AudioManager from "../../Shared/AudioManager";
import UIManager from "../../Shared/UIManager";
import NetworkLogic from "../../Shared/NetworkLogic";
import {Global} from "../../Shared/Global";

const {ccclass, property} = cc._decorator;

@ccclass
export default class NewClass extends cc.Component {

    @property(cc.EditBox)
    editBox: cc.EditBox = null;

    @property(cc.Button)
    btnSubmit: cc.Button = null;



    start () {

    }

    updateUI(list){
        this.editBox.placeholder = "好友账号";
        this.editBox.string = ""
        this.btnSubmit.clickEvents[0].customEventData = list.id ;
    }

    onBtnClose(event,param) {
        AudioManager.playSound("close")
        this.node.active = false;
    }

    onBtnSubmit(event,param){
        AudioManager.playSound("button");
        if (!this.editBox.string){
            UIManager.showToastUI("请先输入账号");
            return;
        }
        let data2 = {
            taskId:param,
            friendUserId:this.editBox.string
        }
        UIManager.showLoadingUI();
        NetworkLogic.agentApplicationReward(data2,function (rec) {
            UIManager.hideLoadingUI();
            //cc.director.emit(Global.UserEvent.UpdateShareTaskBtn,parseInt(param));
            this.node.active = false;
            UIManager.showTipUI("提交申请成功，请等待审核");

        }.bind(this),function () {
            console.log("=====提交错误")
        })

    }

}
